
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/niewystarczajaca-kwota-na-koncie",
      function () {
        return require("private-next-pages/moje-konto/niewystarczajaca-kwota-na-koncie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/niewystarczajaca-kwota-na-koncie"])
      });
    }
  